module.exports = __webpack_public_path__ + "img/forward-field.f32174bd.svg";